import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=bbee7894&scoped=true&"
import script from "./ReportsPage.vue?vue&type=script&lang=js&"
export * from "./ReportsPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportsPage.vue?vue&type=style&index=0&id=bbee7894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbee7894",
  null
  
)

export default component.exports